import axios from "axios";
import DeviceDetector from "device-detector-js";


export default async function submitTroubleTicket(reqData) {
  const deviceDetector = new DeviceDetector();
  const userAgent =
    window && window.navigator ? window.navigator.userAgent : null;
  const device = userAgent ? deviceDetector.parse(userAgent) : null;

  const req = {
    ...reqData,
  };

  if (device) req.device = device;

  return axios
    .post(`/trouble-tickets/`, reqData)
    .then(({ data }) => {
      return true;
    })
    .catch((err) => {
      throw err;
    });
}